module.exports = __webpack_public_path__ + "0b9e7be.webp";